function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, Ref, ElementType, MouseEventHandler, CSSProperties, ReactNode } from 'react';
import cn from 'classnames';
import { Link } from '../Link';
require("./Cut.css");
var styles = {
  "HiddenText": "Cut-module-HiddenText_vhd",
  "EllipsisGradient": "Cut-module-EllipsisGradient_27l"
};
export const Cut = ({
  buttonLess = 'Скрыть',
  buttonMore = 'Еще',
  className,
  tag = 'div',
  ellipsis = /*#__PURE__*/React.createElement("span", {
    className: styles.EllipsisGradient
  }),
  hiddenText,
  innerRef,
  controlRef,
  isExtended = false,
  onToggle,
  visibleText,
  style = {},
  ...props
}) => {
  const Component = tag;
  return /*#__PURE__*/React.createElement(Component, _extends({
    style: style,
    className: cn(styles.Root, className),
    ref: innerRef || controlRef
  }, props), /*#__PURE__*/React.createElement("span", null, visibleText), /*#__PURE__*/React.createElement("span", {
    className: styles.HiddenText,
    "aria-hidden": !isExtended
  }, hiddenText), !isExtended && typeof ellipsis === 'string' && /*#__PURE__*/React.createElement("span", null, ellipsis), !isExtended && /*#__PURE__*/React.isValidElement(ellipsis) && ellipsis, (!isExtended || isExtended && buttonLess) && /*#__PURE__*/React.createElement(Link, {
    tag: "span",
    onClick: onToggle,
    role: "button",
    variant: "default"
  }, isExtended ? buttonLess : buttonMore));
};
if (process.env.NODE_ENV !== 'production') {
  Cut.displayName = 'Cut';
}